import { Clock } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { HOURS_LABEL } from "../../lib/hours";

export const HoursCard = ({ cfg }) => {
  const badge = cfg?.online ? "Equipe online" : cfg?.ai ? "Assistente virtual" : cfg?.in_hours ? "Em horário" : "Fora do horário";
  return (
  <div className="sp-card sp-hours" data-testid="support-hours">
    <span className="sp-hours-icon"><Clock size={18} /></span>
    <div className="min-w-0">
      <p className="sp-eyebrow">Horário de atendimento</p>
      <p className="text-[14.5px] font-semibold mt-0.5">{cfg?.hours || HOURS_LABEL}</p>
      <p className="text-[12.5px] text-[#9DB0A5] mt-0.5">Fora desse horário, atendimento por IA.</p>
    </div>
    <span className={`sp-state ${cfg?.online || cfg?.ai ? "is-on" : ""}`} data-testid="support-online-state">{badge}</span>
  </div>
  );
};

export const FaqList = ({ cfg }) => {
  const faq = Array.isArray(cfg?.faq) ? cfg.faq.filter((f) => f?.q) : [];
  if (!faq.length) return null;
  return (
    <div className="sp-card px-4 py-2" data-testid="support-faq">
      <p className="sp-eyebrow pt-2">Perguntas frequentes</p>
      <Accordion type="single" collapsible>
        {faq.map((f, i) => (
          <AccordionItem key={i} value={`f${i}`} className="border-[#1C2D24]">
            <AccordionTrigger data-testid={`faq-item-${i}`} className="text-left text-[14.5px] hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="text-[14px] text-[#C9D6CE] leading-relaxed whitespace-pre-wrap">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
